import { doc, type DocumentSnapshot } from 'firebase/firestore'
import { getDb } from '@/firebase/firestore'
import { normalizeMap } from '@/firebase/converters'
import type { AlarmDoc, AlarmRecord } from '@/types/firestore'

/* alarms/{alarmId}. getAlarmRefFromId (custom_functions.dart) is literally
 * FirebaseFirestore.instance.collection('alarms').doc(id). */

export function alarmRef(id: string) {
  return doc(getDb(), 'alarms', id)
}

/** AlarmsRecord.fromSnapshot — throws on malformed data (safeGet catches). */
export function parseAlarm(snap: DocumentSnapshot): AlarmRecord {
  const data = normalizeMap(snap.data() ?? {}) as AlarmDoc
  return { ref: snap.ref, data }
}
